export const appropriateUseAndAntiSpamMeasures = [
  {
    header: "Service Overview",
    answer:
      "The Platform is provided by HomeSwap, a private entity. All information available solely to Members and Newcomers is confidential and not publicly accessible.",
  },
  {
    header: "Purpose of Content",
    answer:
      "Content intended exclusively for Members and Newcomers is designed for facilitating Exchanges among Members.",
  },
  {
    header: "Prohibited Uses",
    answer:
      "• The Platform may not be used for promotional or commercial activities. \n \
        • Data mining or the collection and storage of personal information about Members and Newcomers is strictly prohibited. \n \
        • Any attempt to gather or utilize personal data or contact details of Members and Newcomers, for purposes other than arranging an Exchange, is a violation of these Terms.",
  },
  {
    header: "Communication",
    answer:
      "• HomeSwap is not liable for undelivered requests or any lost opportunities resulting from such requests. \n \
        • You remain solely responsible for the content you share and the communications you send. \n \
        • We reserve the right to remove any content that violates the law or these Terms, at our discretion.",
  },
  {
    header: "Spam Policy",
    answer:
      "• HomeSwap does not engage in or support unsolicited commercial emails ('SPAM'). \n \
        • We reserve the right to terminate (without refund) the account of any Member or Newcomer who references HomeSwap or its associated websites, URLs, or email addresses in a SPAM message. \n \
        • Accounts may also be deleted (without refund) if the Platform is used for unsolicited solicitations beyond personal Exchange-related requests. \n \
        • Violations may result in serious consequences, and you release HomeSwap from any liabilities arising from such violations.",
  },
];
